import React from 'react';
import './solutions.css';
import './innovationhub.css';
import { motion } from 'framer-motion';

const InnovationHub = () => {
  return (
    <motion.div className="solutions-container animated-bg" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
      <h1>🚀 Innovation Hub</h1>
      <p>R&D initiatives that spark futuristic solutions and creative experiments.</p>

      <div className="solutions-grid">
        <motion.div className="solution-card" whileHover={{ scale: 1.05 }}>
          <h2>Smart Interfaces</h2>
          <p>Prototyping gesture- and voice-enabled interfaces for next-gen apps.</p>
        </motion.div>
        <motion.div className="solution-card" whileHover={{ scale: 1.05 }}>
          <h2>Edge Innovations</h2>
          <p>Explore boundary-pushing ideas using edge computing and immersive tech.</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default InnovationHub;
